import React, { useEffect, useState } from 'react';
import { Form, Row, Col, Checkbox, Space, Select ,notification} from 'antd';
import FloatLabel from '../../../CustomComponents/FloatingLabel';
import { useSelector } from 'react-redux';
import { CustomRow, SaveButton, CancelButton } from './styledComponents';
import { SaveOutlined, CloseOutlined } from '@ant-design/icons';
import 'react-phone-input-2/lib/style.css';
import {
  getNotificationConfig,
  updateNotificationConfig
} from '../../../../Apis/User';

const { Option } = Select;
const NotificationFlow = ({
  notificationConfig,
  edit,
  setEdit,
  saveLoading
}) => {
  const [form] = Form.useForm();
  const [theme] = useSelector(state => [state.themeReducer]);
  const [user] = useSelector(state => [state.userReducer]);
  const [activateRoster, setActivateRoster] = useState();

  // useEffect(() => {
  //   setActivateRoster(profile.activateRoster ? profile.activateRoster : false);
  //   form.setFieldsValue({
  //     ...profile
  //   });
  // }, [profile]);
  useEffect(() => {
    form.setFieldsValue({
      emrSubmissionFailureNotification:
        !!notificationConfig?.emrSubmissionFailureNotification,
      emrSubmissionSuccessNotification:
        !!notificationConfig?.emrSubmissionSuccessNotification,
      facilityAuthenticationNotification:
        !!notificationConfig?.facilityAuthenticationNotification,
      jobUpdateNotification: notificationConfig?.jobUpdateNotification
    });
  }, []);

  const onFormSubmit = values => {
    const payload = {
      ...values,
      userId: user.id // ✅ Add user ID to payload
    };

    updateNotificationConfig(payload)
    .then(response => {
      if (response.data.success) {
        setEdit(false);
        
        notification['success']({
          message: 'Success',
          description: response.data.message
        });
      } else {
        notification['error']({
          message: 'Failed',
          description: response.data.message
        });
      }
    })
      .catch(error => {
        console.error('Update failed:', error);
        // Optionally show an error message
      });
  };

  const cancelEdit = () => {
    setEdit(false);
    form.resetFields();

    // form.setFieldsValue({ ...profile });
  };

  // const handleCheckboxChange = e => {
  //   setSelfReviewEnabled(e.target.checked);
  // };

  // <Form
  //   form={form}
  //   layout='vertical'
  //   onFinish={values => onFormSubmit(values)}
  // >
  //   <Row justify='center'>
  //     <Col span={24}>
  //       <Form.Item
  //         label='Notifications  Enabled'
  //         name='facilityAuthenticationNotification'
  //         valuePropName='checked'
  //       >
  //         <Checkbox checked={activateRoster} disabled={!edit}>
  //           Enable Facility authentication notifications
  //         </Checkbox>
  //       </Form.Item>
  //     </Col>
  //     <Col span={24}>
  //       <Form.Item name='jobUpdateNotification' valuePropName='checked'>
  //         <Checkbox checked={activateRoster} disabled={!edit}>
  //           Enable Job Update notifications
  //         </Checkbox>
  //       </Form.Item>
  //     </Col>
  //     <Col span={24}>
  //       <Form.Item
  //         name='emrSubmissionSuccessNotification'
  //         valuePropName='checked'
  //       >
  //         <Checkbox checked={activateRoster} disabled={!edit}>
  //           Enable EMR submission success notifications
  //         </Checkbox>
  //       </Form.Item>
  //     </Col>
  //     <Col span={24}>
  //       <Form.Item
  //         name='emrSubmissionFailureNotification'
  //         valuePropName='checked'
  //       >
  //         <Checkbox checked={activateRoster} disabled={!edit}>
  //           Enable EMR submission failed notifications
  //         </Checkbox>
  //       </Form.Item>
  //     </Col>
  //   </Row>

  //   <br />
  //   {edit === true && (
  //     <CustomRow justify='end'>
  //       <Space size={20}>
  //         <CancelButton onClick={cancelEdit} icon={<CloseOutlined />}>
  //           Cancel
  //         </CancelButton>

  //         <SaveButton
  //           type='primary'
  //           htmlType='submit'
  //           icon={<SaveOutlined />}
  //           loading={saveLoading}
  //         >
  //           Save
  //         </SaveButton>
  //       </Space>
  //     </CustomRow>
  //   )}
  // </Form>
  return (
    <Form
      form={form}
      layout='vertical'
      // initialValues={{
      //   emrSubmissionFailureNotification: false,
      //   emrSubmissionSuccessNotification: false,
      //   facilityAuthenticationNotification: false,
      //   jobUpdateNotification: false
      // }}
      onFinish={values => onFormSubmit(values)}
    >
      <Row justify='center'>
        <Col span={24}>
          <Form.Item
            label='Notifications'
            name='facilityAuthenticationNotification'
            valuePropName='checked'
          >
            <Checkbox disabled={!edit}>
              Facility authentication notifications
            </Checkbox>
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item name='jobUpdateNotification' valuePropName='checked'>
            <Checkbox disabled={!edit}>Job Update Notifications</Checkbox>
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item
            name='emrSubmissionSuccessNotification'
            valuePropName='checked'
          >
            <Checkbox disabled={!edit}>
              EMR Submission Success Notifications
            </Checkbox>
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item
            name='emrSubmissionFailureNotification'
            valuePropName='checked'
          >
            <Checkbox disabled={!edit}>
              EMR Submission Failure Notifications
            </Checkbox>
          </Form.Item>
        </Col>
      </Row>
      <br />
      {edit === true && (
        <CustomRow justify='end'>
          <Space size={20}>
            <CancelButton onClick={cancelEdit} icon={<CloseOutlined />}>
              Cancel
            </CancelButton>

            <SaveButton
              type='primary'
              htmlType='submit'
              icon={<SaveOutlined />}
              loading={saveLoading}
            >
              Save
            </SaveButton>
          </Space>
        </CustomRow>
      )}
    </Form>
  );
};

export default NotificationFlow;
